import { components, paths } from "@minuthq/minut-api-types/schema"

import { THomeRole } from "src/data/homes/types/homeTypes"

/*
 * The role within the organization the invited user will have.
 *
 * If not set the user will only see the homes they're explicit members of.
 *
 * If this field is set the user will have access to all homes, with the
 * corresponding home role, belonging to the organization.
 */
export type TOrganizationResponse =
  paths["/organizations/{organization_id}"]["get"]["responses"]["200"]["content"]["application/json"]
export type TOrganizationSalesContact = NonNullable<
  TOrganizationResponse["sales_contact"]
>
export type TOrganizationRole = NonNullable<TOrganizationResponse["user_role"]>

export enum OrganizationRank {
  MINIMUM, // This role is badly named since it's named `minimum`, however the user might be a homegroup admin, and will be able to do a lot more than e.g. an operator
  OPERATOR,
  MEMBER,
  ADMIN,
  OWNER,
}

export interface IOrganizationMember {
  member_id: string
  email: string
  name: string
  role: TOrganizationRole
  user_id?: string // will be present if the member object is the same as the user that made the request
  /** The job-function role picked during onboarding. Unrelated to `role`. */
  job_role?: TJobRole
  /** Free text given when `job_role` is "Other". */
  custom_job_role?: string
}

export type TJobRole = components["schemas"]["JobRole"]

export interface IHomeMember {
  member_id: string
  email: string
  name: string
  role: THomeRole
  user_id?: string // will be present if the member object is the same as the user that made the request
  joined_at?: string
}
